import { IState } from '../store';

export const getIsHiddenOfferByUser = (state: IState) => {
  return Boolean(state.offerData.isHiddenByUser);
};
